import * as echarts from 'echarts'
import {useEffect, useRef} from 'react'
import useWindowSize from '../../utils/useWindowSize'
const LatestTrendChart = ({summary, dataPoint}) => {
    const chartRef = useRef(null)
    const windowSize = useWindowSize()

    useEffect(() => {
        const chartDom = document.getElementById(summary.key)
        if (!chartDom || !dataPoint) {
            return echarts.dispose(chartDom)
        }

        let dataSeries = [...dataPoint]

        if (dataSeries?.length < 7) {
            const remaining = 7 - dataSeries?.length

            for (let i = 0; i < remaining; i++) {
                dataSeries.unshift(0)
            }
        }

        const myChart = echarts.init(chartDom)

        const option = {
            width: '100%',
            height: 50,
            xAxis: {
                show: false,
                type: 'category',
            },
            yAxis: {
                show: false,
                type: 'value',
            },
            grid: {
                containLabel: false,
            },
            series:
                dataSeries && dataSeries?.length > 0
                    ? [
                          {
                              name: summary.label,
                              type: 'line',
                              smooth: false,
                              areaStyle: {color: summary.chartColor},
                              data: dataSeries,
                              lineStyle: {
                                  normal: {
                                      color: summary.chartColor,
                                  },
                              },
                              //   label: {
                              //       show: true,
                              //       position: 'bottom',
                              //       textStyle: {
                              //           fontSize: 12,
                              //       },
                              //   },
                          },
                      ]
                    : [],
        }

        myChart.setOption(option)

        return () => {
            myChart.dispose()
        }
    }, [dataPoint, summary, windowSize])

    return (
        <div
            id={summary.key}
            ref={chartRef}
            className="flex h-10rem p-0"
            style={{width: '100%'}}></div>
    )
}

export default LatestTrendChart
